<template lang="pug">
    div.row.info.p-a.no-gutter(v-if="hasSelected")
        div.col-sm-3.form-inline
            div.form-group
                input.form-control(
                    type="text",
                    placeholder="Search...",
                    :value="tableInstance.query",
                    @keyup="search($event)"
                )
        
        ul.nav.pull-right
            li.nav-item.inline.m-r-sm
                a.nav-link(
                    @click="clearSelected"
                )
                    i.material-icons.md-18.m-r-sm &#xe5cd;
                span.selected-count {{ totalSelected }} selected

            li.nav-item.inline(
                v-for="a in checkboxActions"
            )
                a.btn.btn-outline.b-white.text-white(
                    @click="a.callback"
                ) {{ a.title }}
</template>

<script>
import mixins from '../mixins';
const debounce = require('debounce');

export default {
    mixins: [mixins],

    computed: {
        checkboxActions() {
            let deleteAction = this.legacyCheckboxActions;
            let actions = this.propOptions.checkboxActions || [];

            if (deleteAction) {
                actions.push(deleteAction);
            }

            return actions;
        },

        legacyCheckboxActions() {
            // fix old settings compatibility - delete only
            if (!_.isEmpty(this.propOptions.checkbox_actions)) {
                const text = 'Are you sure to delete the selected items?';
                const title = this.propOptions.checkbox_actions.delete_title;

                return {
                    title,
                    callback: () => {
                        this.swalAlertConfirmationAjax(
                            this.propOptions.checkbox_actions.api_delete,
                            {
                                method: 'delete',
                                paramOptions: {
                                    params: {
                                        ids: this.getSelected,
                                    },
                                },
                                successCallback: () => {
                                    this.tableInstance.getData();
                                    this.clearSelected();
                                },
                                text,
                                title,
                                confirmButtonColor: '#d33',
                                confirmButtonText: 'Yes, delete it',
                            },
                        );
                    },
                };
            } else {
                // might have few actions instead of delete
            }
        },
    },

    methods: {
        search(event) {
            const search = this.tableInstance.serverSearch(
                event,
                this.tableInstance,
            );
            debounce(search, this.tableInstance.opts.debounce);
        },
    },
};
</script>

<style lang="scss" scoped>
.nav-item + .nav-item {
    margin-left: 0.5rem;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/plugins/vuetable2-checkbox/components/header-action.vue